/* URS2GO GA4 ecommerce bridge v2 (2026-10-19)
   Why: the custom web pixel "GA4 Funnel Events" never receives
   product_added_to_cart, and the /cart page does not load gtag.js at all,
   so nothing consumed dataLayer pushes there. This bridge guarantees gtag.js
   exists, watches cart AJAX calls and sends add_to_cart / begin_checkout.
   page_view is never sent here (would double count). */
(function () {
  if (window.__urs2goGa4) return;
  window.__urs2goGa4 = true;

  var MID = 'G-E1SLNGBDNG';
  window.dataLayer = window.dataLayer || [];

  /* keep a real gtag function available even before the script lands */
  var nativeGtag = window.gtag;
  if (typeof nativeGtag !== 'function') {
    window.gtag = function () { window.dataLayer.push(arguments); };
  }

  /* make sure gtag.js itself is loaded on EVERY page (incl. /cart) */
  function ensureGtag() {
    if (!document.querySelector('script[src*="googletagmanager.com/gtag/js"]')) {
      var s = document.createElement('script');
      s.async = true;
      s.src = 'https://www.googletagmanager.com/gtag/js?id=' + MID;
      document.head.appendChild(s);
    }
    if (!window.__urs2goGa4Cfg) {
      window.__urs2goGa4Cfg = true;
      window.gtag('js', new Date());
      window.gtag('config', MID, { send_page_view: false });
    }
  }
  ensureGtag();

  function toItems(lines) {
    return (lines || []).map(function (l) {
      return {
        item_id: String(l.variant_id || l.id || ''),
        item_name: l.product_title || l.title || '',
        item_variant: l.variant_title || '',
        price: (l.price || 0) / 100,
        quantity: l.quantity || 1
      };
    }).filter(function (i) { return i.item_id && i.item_id !== 'undefined'; });
  }

  var lastAtc = 0;
  function sendAddToCart(items) {
    var list = toItems(items);
    if (!list.length) return;
    var now = Date.now();
    if (now - lastAtc < 800) return;
    lastAtc = now;
    var value = list.reduce(function (s, i) { return s + i.price * i.quantity; }, 0);
    window.gtag('event', 'add_to_cart', {
      currency: 'USD',
      value: Math.round(value * 100) / 100,
      items: list,
      transport_type: 'beacon'
    });
    console.log('[urs2go-ga4] add_to_cart sent', list.length);
  }

  function sendBeginCheckout(items) {
    var list = toItems(items);
    if (!list.length) return;
    var value = list.reduce(function (s, i) { return s + i.price * i.quantity; }, 0);
    window.gtag('event', 'begin_checkout', {
      currency: 'USD',
      value: Math.round(value * 100) / 100,
      items: list,
      transport_type: 'beacon'
    });
    console.log('[urs2go-ga4] begin_checkout sent');
  }

  function readCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function isCartWrite(url) {
    if (!url) return false;
    return url.indexOf('/cart/add') > -1 || url.indexOf('/cart/update') > -1;
  }

  window.__urs2goSendBeginCheckout = function () {
    return readCart().then(function (c) { sendBeginCheckout(c.items); }).catch(function () {});
  };

  var origFetch = window.fetch;
  if (origFetch) {
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : ((input && input.url) || '');
      var p = origFetch.apply(this, arguments);
      if (isCartWrite(url)) {
        p.then(function (res) {
          if (res && res.ok) setTimeout(function () {
            readCart().then(function (c) { sendAddToCart(c.items); }).catch(function () {});
          }, 150);
        }, function () {});
      }
      return p;
    };
  }

  if (window.XMLHttpRequest) {
    var origOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      if (isCartWrite(url)) {
        this.addEventListener('load', function () {
          setTimeout(function () {
            readCart().then(function (c) { sendAddToCart(c.items); }).catch(function () {});
          }, 150);
        });
      }
      return origOpen.apply(this, arguments);
    };
  }

  /* checkout intent: capture phase, before navigation */
  document.addEventListener('click', function (e) {
    var t = e.target;
    var el = (t && t.closest)
      ? t.closest("a[href*='/checkout'], button[name='checkout'], input[name='checkout'], #checkout")
      : null;
    if (!el) return;
    if (el.disabled) return;
    if (window.__urs2goBcSent) return;
    window.__urs2goBcSent = true;
    window.__urs2goSendBeginCheckout();
  }, true);

  console.log('[urs2go-ga4] bridge ready (gtag ensured)');
})();
